import { render, staticRenderFns } from "./MPegawai.vue?vue&type=template&id=5bdac441&scoped=true&lang=html&"
import script from "./MPegawai.vue?vue&type=script&lang=js&"
export * from "./MPegawai.vue?vue&type=script&lang=js&"
import style0 from "./MPegawai.vue?vue&type=style&index=0&id=5bdac441&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdac441",
  null
  
)

export default component.exports